export default __webpack_public_path__ + "static/media/template17.c4e83d28.svg";